import TopTenShareholder from '@rebuild/materials/shared/shareholder/TopTenShareholder.vue';

export const componentMap = {
	full: TopTenShareholder
};
